'use strict';
import angular from 'angular';

angular.module('pixels.services', [])

    .factory('pixelsService', ['IORestangular', function (IORestangular) {
        var pixels = IORestangular.all('pixel/getAllServicesForPixelCreation');
        var existingConversionList = IORestangular.all('pixel/getExistingConversionList');
        var getOrders = IORestangular.all('pixel/getOrdersByServiceId');
        var getLineitems = IORestangular.all('pixel/getLineItemsByServiceAndOrderId');
        var lineItem = IORestangular.all('pixel/associatePixelWithLineItems');
        var getPixel = IORestangular.all('pixel/getPixelById');
        var addPixel = IORestangular.all('pixel/addPixel');
        var clusters = IORestangular.all('clusters');
        var clients = IORestangular.all('clients');
        var clientMapping = IORestangular.all('pixel/checkClientAccountMapping');

        var getPixels = function (paramObj) {
            return pixels.customGET(undefined, paramObj, undefined, undefined);
        };
        var getExistingConversionList = function (paramObj) {
            // Using HTTP POST (instead of GET) because there may be too many clusters to fit in the URL.
            return existingConversionList.customPOST(paramObj, undefined, undefined, undefined);
        }
        var getOrdersByServiceId = function (paramObj) {
            return getOrders.customGET(undefined, paramObj, undefined, undefined);
        }
        var getLineItemsByServiceAndOrderId = function (paramObj) {
            return getLineitems.customGET(undefined, paramObj, undefined, undefined);
        }
        var associatePixelToLineItem = function (obj) {
            return lineItem.customPOST(obj, undefined, undefined, undefined);
        }
        var getPixelByIdToEdit = function (paramObj) {
            return getPixel.customGET(undefined, paramObj, undefined, undefined);
        }
        var addConversionTracker = function (obj, paramObj) {
            return addPixel.customPOST(obj, undefined, paramObj, undefined);
        }
        var getClusters = function () {
            return clusters.customGET(undefined, undefined, undefined, undefined);
        };
        var getClients = function (paramObj) {
            return clients.customGET(undefined, paramObj, undefined, undefined);
        };
        var getClientMappingStatus = function (paramObj) {
            return clientMapping.customGET(undefined, paramObj, undefined, undefined);
        };

        return {
            getPixels: getPixels,
            getExistingConversionList: getExistingConversionList,
            getOrdersByServiceId: getOrdersByServiceId,
            getLineItemsByServiceAndOrderId: getLineItemsByServiceAndOrderId,
            associatePixelToLineItem: associatePixelToLineItem,
            getPixelByIdToEdit: getPixelByIdToEdit,
            addConversionTracker: addConversionTracker,
            getClusters: getClusters,
            getClients: getClients,
            getClientMappingStatus: getClientMappingStatus
        }
    }]);